<div class="modal-content">
  <div class="modal-header">
    <div class="kcs-modal-head-text">
      @if (eyebrow) {
        <span class="kcs-modal-eyebrow">{{ eyebrow }}</span>
      }
      <h6 class="modal-title">{{ titolo }}</h6>
      @if (subtitle) {
        <small class="kcs-modal-subtitle">{{ subtitle }}</small>
      }
    </div>
    <button type="button" class="kcs-modal-close" (click)="close()" aria-label="Chiudi">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (testo) {
      <div [innerHtml]="testo | safeHtml"></div>
    }
  </div>
  <div class="modal-footer kcs-modal-footer">
    @for (b of buttons; track b; let last = $last) {
      <p-button
        size="small"
        [label]="b.label"
        [outlined]="isOutlined(b)"
        [severity]="isOutlined(b) ? 'secondary' : severity"
        [class]="last && !isOutlined(b) ? 'kcs-modal-btn-primary' : 'kcs-modal-btn-secondary'"
        (onClick)="doAction(b.action)"
      ></p-button>
    }
  </div>
</div>
